import React, { useEffect, useRef } from 'react';
import Icon from '../../../ui/Icon';
import { ICONS } from '../../../ui/icon-map';

const ColumnMenu = ({ headers, visibleColumns, setVisibleColumns, setShowColumnMenu, headerDisplayNames, isAdmin }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowColumnMenu(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [setShowColumnMenu]);

    const toggleColumn = (e, header) => {
        e.stopPropagation();
        let newVisible = [...(visibleColumns || headers)];
        if (newVisible.includes(header)) {
            newVisible = newVisible.filter(h => h !== header);
        } else {
            newVisible.push(header);
            newVisible.sort((a, b) => headers.indexOf(a) - headers.indexOf(b));
        }
        setVisibleColumns(newVisible);
    };

    return (
        <div
            ref={menuRef}
            className="fixed z-[60] mt-2"
            style={{
                // Using fixed positioning relative to the trigger would be better with a portal,
                // but for now we'll improve the relative positioning container.
                right: '10px',
                top: '40px'
            }}
            role="dialog"
            aria-label="Show or hide columns"
        >
            <div
                className="min-w-[250px] bg-white border border-gray-200 rounded-lg shadow-md normal-case tracking-normal text-left"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between border-b border-gray-200 px-3 py-2">
                    <span className="text-sm font-semibold text-gray-900">Columns</span>
                    <button
                        type="button"
                        onClick={() => setShowColumnMenu(null)}
                        className="text-gray-500 hover:text-gray-900 p-1 rounded hover:bg-gray-100"
                        aria-label="Close column menu"
                    >
                        <Icon glyph={ICONS.close} size="sm" />
                    </button>
                </div>
                <div className="max-h-[300px] overflow-y-auto p-2 space-y-0.5">
                    {headers.map(h => {
                        const isLocked = h === 'updatedBy' && !isAdmin;
                        const inputId = `col-toggle-${h}`;
                        return (
                            <div
                                key={h}
                                className={`flex items-center rounded px-2 py-1 ${isLocked ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-50 cursor-pointer'}`}
                            >
                                <input
                                    id={inputId}
                                    type="checkbox"
                                    checked={!visibleColumns || visibleColumns.includes(h)}
                                    onChange={(e) => {
                                        if (isLocked) return;
                                        toggleColumn(e, h);
                                    }}
                                    disabled={isLocked}
                                    className="rounded text-purple-600 focus:ring-purple-500 border-gray-300"
                                    onClick={(e) => e.stopPropagation()}
                                />
                                <label htmlFor={inputId} className={`ml-2 flex-1 text-sm text-gray-700 ${isLocked ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                                    {headerDisplayNames[h] || h}
                                    {isLocked && (
                                        <span className="ml-1 text-[11px] text-gray-500">(Admin Only)</span>
                                    )}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ColumnMenu;
